import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { environment } from '@environments/environment';
import { Pages } from '@shared/constants';

export const maintenanceGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  if (
    environment.maintenance &&
    route.path !== Pages.MAINTENANCE &&
    segments.length &&
    segments[0].path !== Pages.MAINTENANCE
  ) {
    return inject(Router).parseUrl(Pages.MAINTENANCE);
  }
  return true;
};
